import { NavController, AlertController, ViewController } from "ionic-angular";
import { Injectable } from "@angular/core";

/*
  Generated class for the GeneralServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class cbProviderAlert {
  confirm: any;
  constructor(public alerControl: AlertController) {}

  DoConfirmationWithReasonAlert(message: string): Promise<boolean> {
    let resolveFunction: (confirm: any) => void;

    let promise = new Promise<any>(resolve => {
      resolveFunction = resolve;
    });

    let alert = this.alerControl.create({
      title: "Xác nhận hành động",
      message: message,
      enableBackdropDismiss: false,
      inputs: [
        {
          name: "userInput",
          placeholder: "Ghi chú"
        }
      ],
      buttons: [
        {
          text: "No",
          handler: alertData => resolveFunction(false)
        },
        {
          text: "Yes",
          handler: alertData => resolveFunction(alertData.userInput)
        }
      ]
    });
    alert.present();
    return promise;
  }


  DoManualInputProductQuantity(message: string): Promise<number> {
    let resolveFunction: (confirm: any) => void;

    let promise = new Promise<any>(resolve => {
      resolveFunction = resolve;
    });

    let alert = this.alerControl.create({
      title: "Xác nhận số lượng",
      message: message,
      enableBackdropDismiss: false,
      inputs: [
        {
          name: "userInput",
          placeholder: ""
        }
      ],
      buttons: [
        {
          text: "Thoát",
          handler: alertData => resolveFunction(0)
        },
        {
          text: "Cập nhật",
          handler: alertData => resolveFunction(parseInt(alertData.userInput))
        }
      ]
    });
    alert.present();
    return promise;
  }



  confirmYesNoAlert(
    message: string,
    option1: string,
    option2: string
  ): Promise<boolean> {
    let resolveFunction: (confirm: any) => void;

    let promise = new Promise<any>(resolve => {
      resolveFunction = resolve;
    });

    let alert = this.alerControl.create({
      message: message,
      enableBackdropDismiss: false,

      buttons: [
        {
          text: option1,
          handler: () => resolveFunction(false)
        },
        {
          text: option2,
          handler: () => resolveFunction(true)
        }
      ]
    });
    alert.present();
    return promise;
  }

  confirmAlert(message: string, option1: string): Promise<boolean> {
    let resolveFunction: (confirm: any) => void;

    let promise = new Promise<any>(resolve => {
      resolveFunction = resolve;
    });

    let alert = this.alerControl.create({
      message: message,
      enableBackdropDismiss: false,

      buttons: [
        {
          text: option1,
          handler: () => resolveFunction(true)
        }
      ]
    });
    alert.present();
    return promise;
  }

  DoConfirmationYesNoAlert(message: string): Promise<boolean> {
    let resolveFunction: (confirm: any) => void;

    let promise = new Promise<any>(resolve => {
      resolveFunction = resolve;
    });

    let alert = this.alerControl.create({
      title: "Xác nhận hành động",
      message: message,
      enableBackdropDismiss: false,

      buttons: [
        {
          text: "No",
          handler: () => resolveFunction(false)
        },
        {
          text: "Yes",
          handler: () => resolveFunction(true)
        }
      ]
    });
    alert.present();
    return promise;
  }

  DoPresentAlert(pTitle, pMessage) {
    let alert = this.alerControl.create({
      title: pTitle,
      subTitle: pMessage,
      buttons: [
        {
          text: "Ok",
          role: "cancel",
          handler: () => {
            console.log("Cancel clicked");
          }
        }
      ]
    });
    alert.present();
  }
}



// WEBPACK FOOTER //
// ./src/providers/general-service/cbProviderAlert.ts